import { render, staticRenderFns } from "./QuotationToYard.vue?vue&type=template&id=8b7a401e&"
import script from "./QuotationToYard.vue?vue&type=script&lang=js&"
export * from "./QuotationToYard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports